import {ReportSubscriberState} from '../state/reportSubscriberState';
import {FETCH_COUNTRY_LIST_DATA,Fetch_All_Region_Data1, Fetch_All_Users_Data , User_Data_Success} from '../action/reportSubscriberAction';

export function ReportSubscriberReducer(state = ReportSubscriberState, action) {
   
    switch(action.type){
        case Fetch_All_Region_Data1:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                regionList : action.regionList
            })
       
            case Fetch_All_Users_Data:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                userList : action.userList,
            })
            case FETCH_COUNTRY_LIST_DATA:
                        return Object.assign({}, state, {
                            countryList : action.list
                        })
            case User_Data_Success:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.Message,
            })
        default:
            return state
    }
}